import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function ShareRedirectPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const resolve = async () => {
      const { data } = await supabase
        .from('share_links')
        .select('target_type, target_id')
        .eq('code', code)
        .single();

      if (data) {
        const redirect = data.target_type === 'project'
          ? `/project/${data.target_id}`
          : `/project/${data.target_id}`;
        navigate(redirect, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    };
    resolve();
  }, [code, navigate]);

  return <div className="container mt-24 text-secondary">Redirecting...</div>;
}
